import { ChatBotWrapper, ChatToggleButton } from '$components/chat-bot';
import { useChatBotContext } from '$components/chat-bot/chat-bot-context';

export function ChatBot() {
  const { isOpen, toggleChat, closeChat } = useChatBotContext();

  return (
    <>
      <ChatToggleButton isOpen={isOpen} onClick={toggleChat} />
      <ChatBotWrapper isOpen={isOpen} onClose={closeChat} />
    </>
  );
}
